import React, { useContext } from "react";
import { Typography, Box, useTheme, Avatar } from "@mui/material";
import { SiteContext } from "gatsby-frontend/src/Site";
import { SingleContext } from "gatsby-frontend/src/Page";
import { Breadcrumbs, Date, BookmarkToggle, Share } from "../../";

function TitleBlog({
	title,
	title_append,
	subtitle,
	hasDates,
	dates,
	dateFormat,
	vCard,
	image,
	isReversed,
	shareButtons,
}) {
	const theme = useTheme();
	const { bookmarkableBundles } = useContext(SiteContext);
	const { ancestors, bundle } = useContext(SingleContext);
	const showBookmarkToggle =
		process.env.GATSBY_IS_BOOKMARK_PAGES_ENABLED &&
		bookmarkableBundles.includes(bundle);
	// Defnine manually this components for some projects thet might need to reverse the order
	const Dates = () => {
		if (!hasDates) {
			return null;
		}
		return (
			<Date
				dates={dates}
				single
				format={dateFormat}
				sx={{ marginTop: theme.spacing(1) }}
			/>
		);
	};

	const Subtitle = () => {
		if (!subtitle) {
			return null;
		}
		return (
			<Typography
				component="em"
				sx={{
					marginTop: theme.spacing(2),
					fontStyle: "normal",
					display: "block",
				}}
			>
				{subtitle}
			</Typography>
		);
	};

	const isSideShare = theme?.customOptions?.shareLocation === 'side';

	return (
		<Box
			className="title-blog"
			sx={{
				borderBottom: `2px solid ${theme.palette.grey[300]}`,
				paddingBottom: theme.spacing(3),
				marginTop: theme.spacing(2),
				marginBottom: theme.spacing(4),
				"& a": { color: theme.palette.link.main },
				"& .MuiSvgIcon-root": {
					display: "block",
				},
				"& + .intro-box": {
					marginTop: theme.spacing(-2),
				},
			}}
		>
			{ancestors && ancestors.length > 0 && (
				<Box sx={{ marginBottom: theme.spacing(2) }}>
					<Breadcrumbs ancestors={ancestors} title={title} />
				</Box>
			)}
			<Box
				sx={{
					...(vCard &&
						image && {
							display: "flex",
							marginTop: theme.spacing(4),
							alignItems: "center",
						}),
				}}
			>
				{vCard && image && (
					<Avatar
						src={image.src}
						sx={{
							width: theme.spacing(10),
							height: theme.spacing(10),
							marginRight: theme.spacing(2),
						}}
					/>
				)}
				<Box className="titles-box">
					<Typography component="h1" variant="h1">
						{title}
						{title_append && (
							<>
								{", "}
								<small>{title_append}</small>
							</>
						)}
						{showBookmarkToggle && <BookmarkToggle />}
					</Typography>
					{(isReversed ? [Dates, Subtitle] : [Subtitle, Dates]).map(
						(Component) => (
							<Component key={Component.name} />
						)
					)}
					{!isSideShare && shareButtons && shareButtons.length > 0 && (
						<Share
							buttons={shareButtons}
							color={theme.palette.body.contrastText}
						/>
					)}
				</Box>
			</Box>
		</Box>
	);
}

export default TitleBlog;
